
import { LoadingOutlined } from '@ant-design/icons'
import { Button, Card, Col, Empty, Flex, Form, Row, Space, Spin, Tag, Typography } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { UploadChangeParam, UploadFile } from 'antd/es/upload'
import { isEmpty } from 'lodash-es'
import { FunctionComponent, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Vector } from '../../assets/svg/Index'
import { InputForm } from '../../components/form/InputForm'
import { SingleImageUploadForm } from '../../components/form/SingleImageUploadForm'
import { CategoryModel } from '../../models/CategoryModel'
import { GeminiModel } from '../../models/GeminiModel'
import { ImageModel } from '../../models/ImageModel'
import { CategoryService } from '../../services/CategoryService'
import { GeminiService } from '../../services/GeminiService'
import { Color } from '../../styles/Color'
import { MenuType } from '../../types/MenuType'
import { NavigationType } from '../../types/NavigationType'
import LocalStorageUtility from '../../utils/LocalStorageUtility'
import { Container } from '../layout/Container'
import { LayoutContainer } from '../layout/LayoutContainer'

export const 상표등록V2: FunctionComponent = () => {
    const location = useLocation()
    const navigate = useNavigate()

    const { state } = location

    const [isLoading, setLoading] = useState<boolean>(false)
    const [isGeminiLoading, setGeminiLoading] = useState<boolean>(false)
    const [category, setCategory] = useState<CategoryModel.ITrademarkCategoryModel>()
    const [attachment, setAttachment] = useState<ImageModel.IAttachmentImageModel | undefined>()
    const [flattenCategories, setFlattenCategories] = useState<Array<CategoryModel.ITrademarkCategoryFlattenModel>>([])
    const [recommend, setRecommend] = useState<GeminiModel.IGeminiMarkerModel | null>(null)
    const [recommends, setRecommends] = useState<Array<GeminiModel.IGeminiMarkerModel> | null>(
        null
        // [
        //     {
        //         "category": "음식점메뉴/가공식품",
        //         "subcategory": "국수/만두/샌드위치/죽/피자/곡물 위주의 주식",
        //         "recommend": "김밥은 밥을 주재료로 하는 곡물 위주의 주식이며, '빠르고 간편한 포장'으로 '건강한 한끼' 식사를 제공하는 가공식품의 형태이므로 해당 서브카테고리의 특징과 부합합니다.",
        //         "classes": [
        //             "30",
        //             "35",
        //             "43",
        //             "29",
        //             "18",
        //             "28"
        //         ]
        //     },
        //     {
        //         "category": "요식업/식품",
        //         "subcategory": "식품 가공업",
        //         "recommend": "'후루루하하'가 좋은 식자재를 엄선하여 김밥을 직접 '제조'하고 '가공'하는 행위를 포함하므로, 식품을 생산하고 변형하는 산업 활동에 해당합니다.",
        //         "classes": [
        //             "40",
        //             "35",
        //             "29",
        //             "43",
        //             "30",
        //             "42"
        //         ]
        //     },
        //     {
        //         "category": "요식업/식품",
        //         "subcategory": "식품매장/온라인몰(식음료/주류/건강기능식품)",
        //         "recommend": "'프리미엄 건강식' 김밥이라는 제품을 소비자에게 유통하고 판매하는 온/오프라인 매장 운영을 포함하며, '건강식'이라는 특성이 해당 서브카테고리명과도 연관됩니다.",
        //         "classes": [
        //             "09",
        //             "35",
        //             "38",
        //             "42",
        //             "41",
        //             "36",
        //             "16"
        //         ]
        //     }
        // ]
    )

    const [form] = Form.useForm()

    const handleGemini = async () => {
        const description: string | null = form.getFieldValue('description')
        if ((description?.length ?? 0) <= 0) {
            alert('상품/서비스 정보를 입력해 주세요!')
            return
        }

        setGeminiLoading(true)
        const response = await GeminiService.analytics(description!)
        if (response.status === 200) {
            setRecommends(response.data.item)
        }
        setGeminiLoading(false)
    }

    const getCategories = async () => {
        setLoading(true)
        const response = await CategoryService.search()
        if (response.status === 200) {
            setCategory(response.data)
        }
        setLoading(false)
    }

    const getFlattenCategories = async () => {
        setLoading(true)
        const response = await CategoryService.flatten()
        if (response.status === 200) {
            setFlattenCategories(response.data)
        }
        setLoading(false)
    }

    useEffect(() => {
        const userData = LocalStorageUtility.get('user')
        if (!userData) {
            alert('로그인 후 진행해주세요.')
            window.location.href = '/login'
        }

        if (state) {
            form.setFieldValue('name', state.keyword)
        }

        getCategories()
        getFlattenCategories()

        // form.setFieldValue('name', '후루루하하')
        // form.setFieldValue('alphabet', 'hoorooroohaha')
        // form.setFieldValue('description', '후루루하하는 기존 김밥들과 달리 밥양을 줄이고 부속 재료들이 더 많은 프리미엄 건강식 입니다. 매일 좋은 식자재들을 엄선하여 프레쉬하고 건강한 한끼 식사 빠르고 간편한 포장으로 간단하지만 영양 풍부한 한끼!적은 탄수화물과 고단백질 식사로 건강도 챙겨요!.')
    }, [])

    return (
        <Container type={NavigationType.White} menu={MenuType.상표등록}>
            <Spin
                fullscreen
                size='large'
                indicator={<LoadingOutlined spin style={{ color: '#92e3ff' }} />}
                spinning={isLoading || isGeminiLoading}
                tip={isLoading ? '' : 'AI 분석을 진행중입니다...'}
                className='gemini-loading'
            />
            <Row
                gutter={[0, 12]}
                className='create-trademark-container'
            >
                <Col span={24}>
                    <LayoutContainer style={{ gap: 20, }}>
                        <Col span={24}>
                            <Typography.Text
                                style={{
                                    fontSize: 28,
                                }}
                            >
                                <Typography.Text
                                    strong
                                    style={{
                                        fontSize: 28,
                                        color: Color.Blue50,
                                    }}
                                >
                                    {`어디에 사용`}
                                </Typography.Text>
                                {`되는 `}
                                <Typography.Text
                                    strong
                                    style={{
                                        fontSize: 28,
                                        color: Color.Blue50,
                                    }}
                                >
                                    {`상표`}
                                </Typography.Text>
                                {`인가요?`}
                            </Typography.Text>
                        </Col>
                    </LayoutContainer>
                </Col>
                <Col span={24}>
                    <LayoutContainer style={{ gap: 0, marginTop: 20, }}>
                        <Col span={24}>
                            <Typography.Text
                                style={{
                                    fontSize: 18,
                                }}
                            >
                                <Typography.Text
                                    strong
                                    style={{
                                        fontSize: 18,
                                    }}
                                >
                                    {`한글/영어 모두 입력`}
                                </Typography.Text>
                                {`해야`}
                            </Typography.Text>
                        </Col>
                        <Col span={24}>
                            <Typography.Text
                                style={{
                                    fontSize: 18,
                                }}
                            >
                                <Typography.Text
                                    strong
                                    style={{
                                        fontSize: 18,
                                    }}
                                >
                                    {`정확한 등록 가능성`}
                                </Typography.Text>
                                {`을 확인할 수 있어요!`}
                            </Typography.Text>
                        </Col>
                    </LayoutContainer>
                </Col>
                <Col span={24}>
                    <Form form={form}>
                        <LayoutContainer style={{ gap: 20, }}>
                            <Col span={24} style={{ marginTop: 20, }}>
                                <Row gutter={[0, 20]}>
                                    <Col span={24}>
                                        <Typography.Text
                                            strong
                                            style={{
                                                fontSize: 20,
                                            }}
                                        >
                                            {`상표의 명칭 (한글, 한글 + 영어)`}
                                        </Typography.Text>
                                    </Col>
                                    <InputForm
                                        name='name'
                                        placeholder='상표명을 한글 또는 한글 + 영어로 입력하세요'
                                        style={{
                                            height: 50,
                                            borderRadius: 30,
                                            fontSize: 16,
                                            paddingLeft: 30,
                                        }}
                                        layout={{ lg: { span: 12 }, sm: { span: 12 }, xs: { span: 24 } }}
                                    />
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[0, 20]}>
                                    <Col span={24}>
                                        <Typography.Text
                                            strong
                                            style={{
                                                fontSize: 20,
                                            }}
                                        >
                                            {`상표의 명칭 (영어)`}
                                        </Typography.Text>
                                    </Col>
                                    <InputForm
                                        name='alphabet'
                                        placeholder='상표명을 영어로 입력하세요'
                                        style={{
                                            height: 50,
                                            borderRadius: 30,
                                            fontSize: 16,
                                            paddingLeft: 30,
                                        }}
                                        layout={{ lg: { span: 12 }, sm: { span: 12 }, xs: { span: 24 } }}
                                    />
                                </Row>
                            </Col>
                            <Col span={24} style={{ marginBottom: 20, }}>
                                <Row gutter={[0, 20]} style={{ marginBottom: 18 }}>
                                    <Col span={24}>
                                        <Typography.Text
                                            strong
                                            style={{
                                                fontSize: 20,
                                            }}
                                        >
                                            {`[선택] 상표/로고/캐릭터(도면)`}
                                        </Typography.Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col
                                        {...{ xs: 24, md: 12, lg: 10, xl: 12 }}
                                        style={{
                                            borderRadius: 20,
                                            borderWidth: 1,
                                            borderColor: Color.Gray50,
                                            borderStyle: 'solid',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <SingleImageUploadForm
                                            path={"https://api.markerslab.app/attachment"}
                                            onUploaded={(uploadedFile: UploadChangeParam<UploadFile<any>>) => {
                                                if (uploadedFile.file.response?.id) {
                                                    setAttachment(uploadedFile.file.response)
                                                    setLoading(false)
                                                } else {
                                                    setLoading(true)
                                                }
                                            }}
                                        >
                                            <Row justify={"center"} align={'middle'} style={{ height: 214, }}>
                                                {!attachment && (
                                                    <Col span={24} style={{ textAlign: 'center' }}>
                                                        <Space direction='vertical'>
                                                            <img src={Vector.icon.camera.black} alt="camera" />
                                                            <Typography.Text
                                                                style={{
                                                                    fontSize: 18,
                                                                    color: Color.Gray60
                                                                }}
                                                            >
                                                                {'이미지를 업로드 해주세요'}
                                                            </Typography.Text>
                                                        </Space>
                                                    </Col>
                                                )}
                                                {attachment && (
                                                    <Col span={24} style={{ textAlign: 'center', width: '100%', height: '100%' }}>
                                                        <img
                                                            src={attachment.url}
                                                            alt={'상표/로고/캐릭터(도면)'}
                                                            height={'100%'}
                                                            width={'100%'}
                                                            style={{ objectFit: 'contain' }}
                                                        />
                                                    </Col>
                                                )}
                                            </Row>
                                        </SingleImageUploadForm>

                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[0, 20]}>
                                    <Col span={24}>
                                        <Space direction='vertical'>
                                            <Typography.Text
                                                strong
                                                style={{
                                                    fontSize: 20,
                                                }}
                                            >
                                                {`[필수] 상품/서비스 정보`}
                                            </Typography.Text>
                                            <Typography.Text
                                                style={{
                                                    fontSize: 16,
                                                    color: Color.Gray60
                                                }}
                                            >
                                                {`상표가 사용될 상품이나 서비스에 대해 자세하게 설명해주세요.`}
                                            </Typography.Text>
                                        </Space>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            name="description"
                                        >
                                            <TextArea
                                                allowClear
                                                placeholder={'ex) 뷰티 서비스를 준비중에 있습니다. \n앱/웹 서비스 출시 예정이고, 추후 유통 판매까지\n생각하고 있습니다.'}
                                                maxLength={400}
                                                autoSize={{
                                                    minRows: 5
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        </LayoutContainer>
                    </Form>
                </Col>
                <Col span={24}>
                    <LayoutContainer style={{ gap: 20, }}>
                        <Row gutter={[12, 12]}>
                            {(recommends?.length ?? 0) > 0 && (
                                <>
                                    <Col span={24}>
                                        <Typography.Text
                                            strong
                                            style={{
                                                fontSize: 20,
                                            }}
                                        >
                                            {`[필수] AI 분석 결과에서 원하시는 상품류를 선택해 주세요!`}
                                        </Typography.Text>
                                    </Col>
                                    {recommends?.map((r, idx: number) => {
                                        const isActivated = recommend == r

                                        return (
                                            <Col
                                                key={r.subcategory}
                                                {...{ xs: 24, md: 12, lg: 8 }}
                                            >
                                                <Card
                                                    variant='outlined'
                                                    hoverable
                                                    onClick={() => {
                                                        setRecommend(r)
                                                    }}
                                                    style={{
                                                        borderColor: isActivated ? '#36afd9' : '#f0f0f0',
                                                        borderWidth: isActivated ? 2 : 1,
                                                        backgroundColor: isActivated ? '#36afd917' : '#fff',
                                                    }}
                                                >
                                                    <Space direction='vertical'>
                                                        <Space>
                                                            <Typography.Text strong>{r.category}</Typography.Text>
                                                            {idx === 0 && <Tag color='geekblue'>추천</Tag>}
                                                        </Space>
                                                        <Space direction='vertical' size={0}>
                                                            <Typography.Text style={{ color: '#999' }}>{`[${r.subcategory}]`}</Typography.Text>
                                                            {(r.classes?.length ?? 0) > 0 && (
                                                                <Space>
                                                                    <Typography.Text
                                                                        style={{ color: '#999' }}
                                                                    >
                                                                        {`대표상품류: `}
                                                                    </Typography.Text>
                                                                    <Typography.Text
                                                                        style={{ color: '#999' }}
                                                                    >
                                                                        {`${[...r.classes ?? []].splice(0, 1)}류`}
                                                                    </Typography.Text>
                                                                </Space>
                                                            )}
                                                            {(r.classes?.length ?? 0) > 0 && (
                                                                <Space>
                                                                    <Typography.Text
                                                                        style={{ color: '#999' }}
                                                                    >
                                                                        {`연관상품류: `}
                                                                    </Typography.Text>
                                                                    <Space wrap split={'/'} size={2} style={{ color: '#999' }}>
                                                                        {[...r.classes ?? []].splice(1).map((s) => {
                                                                            return (
                                                                                <Typography.Text
                                                                                    key={s}
                                                                                    style={{ color: '#999' }}
                                                                                >
                                                                                    {`${s}류`}
                                                                                </Typography.Text>
                                                                            )
                                                                        })}
                                                                    </Space>
                                                                </Space>
                                                            )}
                                                        </Space>
                                                        <Space direction='vertical'>
                                                            <Typography.Text>{r.recommend}</Typography.Text>
                                                        </Space>
                                                    </Space>
                                                </Card>
                                            </Col>
                                        )
                                    })}
                                </>
                            )}
                        </Row>
                        {recommends && (recommends.length ?? 0) <= 0 && !isGeminiLoading && (
                            <Col span={24} style={{ justifyContent: 'center', paddingTop: 32, paddingBottom: 32, }}>
                                <Empty
                                    imageStyle={{ height: 0 }}
                                    description={
                                        <Space direction="vertical">
                                            <Typography.Text>
                                                분석 결과가 없어요
                                            </Typography.Text>
                                            <Typography.Text strong>
                                                상품 및 서비스 정보를 조금 더 자세히 작성해주세요!
                                            </Typography.Text>
                                        </Space>
                                    }
                                />
                            </Col>
                        )}
                    </LayoutContainer>
                </Col>
                <Col span={24} style={{ marginTop: 20 }}>
                    <LayoutContainer style={{ justifyContent: 'center' }}>
                        <Col span={12}>
                            <Flex gap={12}>
                                {(recommends?.length ?? 0) > 0 && (
                                    <Button
                                        block
                                        size='large'
                                        style={{ textAlign: 'center', paddingBlock: 24 }}
                                        onClick={() => {
                                            setRecommend(null)

                                            form.validateFields()
                                                .then((values) => {
                                                    if (isEmpty(values.name) && isEmpty(values.alphabet)) {
                                                        alert('상표의 명칭을 하나 이상 입력하세요(한글 또는 영어)')
                                                        return
                                                    }

                                                    if (isEmpty(values.description)) {
                                                        alert('상품/서비스 정보를 입력하세요')
                                                        return
                                                    }

                                                    if (/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(values.alphabet)) {
                                                        alert('상표의 명칭(영어)은 영어만 입력하세요.')
                                                        return
                                                    }

                                                    handleGemini()
                                                })
                                                .catch((e) => {
                                                    return
                                                })
                                        }}
                                    >
                                        {'다시 검색하기'}
                                    </Button>
                                )}
                                <Button
                                    block
                                    size='large'
                                    type='primary'
                                    style={{ textAlign: 'center', paddingBlock: 24 }}
                                    onClick={() => {
                                        form.validateFields()
                                            .then((values) => {
                                                if (isEmpty(values.name) && isEmpty(values.alphabet)) {
                                                    alert('상표의 명칭을 하나 이상 입력하세요(한글 또는 영어)')
                                                    return
                                                }

                                                if (isEmpty(values.description)) {
                                                    alert('상품/서비스 정보를 입력하세요')
                                                    return
                                                }

                                                if (/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(values.alphabet)) {
                                                    alert('상표의 명칭(영어)은 영어만 입력하세요.')
                                                    return
                                                }

                                                if ((recommends?.length ?? 0) > 0) {
                                                    if (recommend) {
                                                        navigate('/trademark-able', {
                                                            state: {
                                                                ...form.getFieldsValue(),
                                                                attachment: attachment,
                                                                categories: [flattenCategories.find(f => f.c4 === recommend.subcategory)],
                                                                recommend: recommend,
                                                            }
                                                        })
                                                    } else {
                                                        alert('상품류를 선택해 주세요!')
                                                    }
                                                } else {
                                                    handleGemini()
                                                }
                                            })
                                            .catch((e) => {
                                                return
                                            })
                                    }}
                                >
                                    {(recommends?.length ?? 0) > 0 ? '상표 등록하기' : 'AI 상표 분석하기'}
                                </Button>
                            </Flex>
                        </Col>
                    </LayoutContainer>
                </Col>
            </Row>
        </Container>
    )
}